"use strict";

angular.module('backstage.services').factory('btGenerateUniqueId', /* @ngInject */
function () {
  return function btGenerateUniqueId(prefix, suffix) {
    return [prefix || '', new Date().getTime().toString(36), Math.round(Math.random() * 1e9).toString(36), suffix || ''].filter(function (el) {
      return el;
    }).join('-');
  };
});